import { render, staticRenderFns } from "./PoliciesFull.vue?vue&type=template&id=8ad296e0"
import script from "./PoliciesFull.vue?vue&type=script&lang=js"
export * from "./PoliciesFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports